<template>
  <div class="wave-accounts">
    <h2 class="mb-3">Wave Accounts</h2>

    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <div v-else>
      <!-- Assets -->
      <h3 class="mt-4 mb-3">Assets</h3>
      <div class="row mb-4">
        <div v-for="account in assets" :key="account.id" class="col-12 col-md-6 mb-3">
          <account-card :account="account" :expanded="true" />
        </div>
        <div v-if="!assets.length" class="col-12">
          <p class="text-muted">No asset accounts found</p>
        </div>
      </div>

      <!-- Liabilities -->
      <h3 class="mt-4 mb-3">Liabilities</h3>
      <div class="row mb-4">
        <div v-for="account in liabilities" :key="account.id" class="col-12 col-md-6 mb-3">
          <account-card :account="account" :expanded="true" />
        </div>
        <div v-if="!liabilities.length" class="col-12">
          <p class="text-muted">No liability accounts found</p>
        </div>
      </div>

      <!-- Income -->
      <h3 class="mt-4 mb-3">Income</h3>
      <div class="row mb-4">
        <div v-for="account in incomes" :key="account.id" class="col-12 col-md-6 mb-3">
          <account-card :account="account" :expanded="true" />
        </div>
        <div v-if="!incomes.length" class="col-12">
          <p class="text-muted">No income accounts found</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import AccountCard from '@/app/components/AccountCard.vue'

const store = useStore()
const loading = ref(true)
const error = ref(null)
const accounts = ref([])

const assets = computed(() =>
  accounts.value.filter(a => a.type?.value === 'ASSET' && parseFloat(a.balance) !== 0)
)

const liabilities = computed(() =>
  accounts.value.filter(a => a.type?.value === 'LIABILITY' && parseFloat(a.balance) !== 0)
)

const incomes = computed(() =>
  accounts.value.filter(a => a.type?.value === 'INCOME' && parseFloat(a.balance) !== 0)
)

onMounted(async () => {
  try {
    const response = await store.state.api.get('/plugins/wave/accounts')
    accounts.value = response.data.accounts || []
  } catch (err) {
    error.value = err.response?.data?.error || err.message || 'Failed to load accounts'
  } finally {
    loading.value = false
  }
})
</script>
